module.exports = __webpack_public_path__ + "static/media/favicon.7b81d4ba.png";